import React from 'react'

function Button({ children, ...rest }) {

  return (
    <button {...rest} className="btn btn-mlm btn-round btn-fill btn-block">{children}</button>
  )
}

export default Button